import React, { useState, useEffect, useContext } from 'react';
import { MainContentContainer, Title } from './style';
import * as Styled from './tabStyle';
import { constants } from '../../../constants/Constants';
import { ThemeContext } from '../../../context/ThemeContext';
import { FilterContext } from '../../../components/FilterBar/FilterProvider';
import TabButton from './TabButton';

interface MainContentProps {
  tabArray?: any[];
  product?: any;
  model?: any;
}

// Detect Firefox
const isFirefox = () => {
  // 1. SSR & Environment Check: Ensure code is running in a browser
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  // 2. normalize user agent string to lowercase for safe matching
  const ua = navigator.userAgent.toLowerCase();

  // 3. Check for the 'firefox' token
  return ua.includes('firefox');
};

const MainContent: React.FC<MainContentProps> = ({
  tabArray,
  product,
  model,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const { setSelectedTab } = useContext(FilterContext);
  const firefox = isFirefox();
  const { mode } = useContext(ThemeContext);
  const isInitialized = React.useRef(false);
  const prevProductIdRef = React.useRef<any>(null);
  const prevModelIdRef = React.useRef<any>(null);

  const handleTabClick = (index: number) => {
    setSelectedIndex(index);
    if (tabArray && tabArray[index]) {
      setSelectedTab(tabArray[index]);
    }
  };

  // Initialize selected tab only once when component mounts
  useEffect(() => {
    if (tabArray && tabArray.length > 0 && !isInitialized.current) {
      setSelectedIndex(0);
      setSelectedTab(tabArray[0]);
      isInitialized.current = true;
    }
  }, [tabArray, setSelectedTab]);

  // Reset selected index when product or model changes
  useEffect(() => {
    const currentProductId =
      typeof product === 'object' ? product?.productId : product;
    const currentModelId = typeof model === 'object' ? model?.id : model;

    const productChanged =
      prevProductIdRef.current !== null &&
      prevProductIdRef.current !== currentProductId;
    const modelChanged =
      prevModelIdRef.current !== null &&
      prevModelIdRef.current !== currentModelId;

    if (productChanged || modelChanged) {
      setSelectedIndex(0);
      if (tabArray && tabArray.length > 0) {
        setSelectedTab(tabArray[0]);
      }
    }

    prevProductIdRef.current = currentProductId;
    prevModelIdRef.current = currentModelId;
  }, [product, model, tabArray, setSelectedTab]);

  // Get the selected tab object
  const selectedTab = tabArray?.[selectedIndex];

  const productName =
    typeof product === 'object'
      ? product?.productId === constants?.products?.GuidedSelling
        ? 'GS ' + model?.label
        : product?.productName
      : product;

  return (
    <MainContentContainer theme={{ mode }}>
      <Title theme={{ mode }}>{productName}</Title>
      {/* <CardContainer title={title} isAccordion={false}> */}
      <Styled.TabsWrapper>
        <Styled.TabsContainer>
          {tabArray?.map((tab, index) => (
            <TabButton
              key={tab.id}
              label={tab.label}
              isActive={selectedIndex === index}
              onClick={() => handleTabClick(index)}
              mode={mode}
            />
          ))}
        </Styled.TabsContainer>
        {selectedTab && (
          <Styled.TabContentContainer
            data-tab-content="true"
            className={firefox ? 'firefox-windows' : ''}
          >
            <selectedTab.component />
          </Styled.TabContentContainer>
        )}
      </Styled.TabsWrapper>
      {/* </CardContainer> */}
    </MainContentContainer>
  );
};

export default MainContent;
